import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@prezi/dragon';
import { CloseIcon } from '../Icons';

type Props = {
    label: string;
    disabled?: boolean;
    maxWidth?: number;
    onClick?: () => void;
    onDelete?: () => void;
};

const Wrap = styled.div<{ maxWidth?: number; disabled: boolean }>`
    display: flex;
    max-width: ${p => (p.maxWidth ? `${p.maxWidth}px` : '100%')};
    position: relative;
    align-items: center;
    border-radius: 1.5em;
    background-color: ${Colors.neutral60};
    padding: 0.25em 2em 0.25em 1em;
    margin: 0.25em;
    font-size: 1em;
    color: ${p => (p.disabled ? Colors.neutral200 : Colors.neutral500)};

    &::after {
        content: attr(data-text);
        position: absolute;
        line-height: 1.4;
        opacity: 0;
        background-color: ${Colors.neutral800};
        color: ${Colors.white};
        font-size: 0.75em;
        border-radius: 2px;
        padding: 0.1em 0.25em;
        left: 50%;
        transform: translate(-50%, 2em);
        word-wrap: break-word;
        max-width: 100%;
        pointer-events: none;
        transition: opacity 0.2s;
        z-index: 1;
    }

    &:hover::after {
        opacity: 1;
        transition: opacity 0.2s 0.75s;
    }

    & span {
        position: relative;
        overflow: hidden;
    }
`;

const CloseButton = styled.div<{ isHoverable: boolean }>`
    position: absolute;
    right: 0.25em;
    border-radius: 50%;
    width: 1.5em;
    height: 1.5em;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.25s;
    margin-left: 0.37em;
    color: inherit;
    ${p => (p.isHoverable ? 'cursor: pointer;' : '')}

    &:hover {
        ${p => (p.isHoverable ? `background-color: ${Colors.neutral100};` : '')};
    }
`;

const Tag = ({ label, disabled = false, maxWidth, onClick, onDelete }: Props) => {
    return (
        <Wrap disabled={disabled} data-text={label} maxWidth={maxWidth} onClick={onClick}>
            <span>#{label}</span>
            <CloseButton data-testid="tag-delete" isHoverable={!disabled} onClick={onDelete}>
                <CloseIcon width={24} height={24} fill="currentColor" />
            </CloseButton>
        </Wrap>
    );
};

export default Tag;
